import { clientConfig } from '@/store'

export function applyClientChrome(): void {
  const config = clientConfig.config

  if (typeof document !== 'undefined') {
    document.title = config.displayName || 'TV'
  }

  if (typeof document !== 'undefined' && !clientConfig.isAccuweather) {
    setFavicon(clientConfig.faviconHref)
  }
}

function setFavicon(href: string): void {
  const existing = document.querySelectorAll('link[rel~="icon"]') as NodeListOf<HTMLLinkElement>
  existing.forEach((el) => {
    el.setAttribute('href', href)
    el.removeAttribute('type')
    el.removeAttribute('sizes')
  })
  if (existing.length === 0) {
    const link = document.createElement('link')
    link.rel = 'icon'
    link.href = href
    document.head.appendChild(link)
  }
}
